import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { Link } from "react-router-dom";
import { usePublicSiteContent } from "../../hooks/useSiteContent";
import { whatsappUrl } from "../../lib/siteContentStore";

const packages = [
  { title: "1. Hisse", type: "Dana", kg: "30–35 kg", price: "₺35.000" },
  { title: "2. Hisse", type: "Dana", kg: "40–45 kg", price: "₺41.000" },
  { title: "3. Hisse", type: "Dana", kg: "50–55 kg", price: "₺47.500" },
  { title: "4. Hisse", type: "Dana", kg: "60–65 kg", price: "₺54.000" },
  { title: "Düve", type: "Düve", kg: "35–40 kg", price: "₺33.000" },
];

const services = [
  { icon: "ri-group-line", title: "Hisseli Satış", desc: "Broşürdeki hisse paketleri üzerinden ön satış alınır. Hisse bağlantısı daha sonra uygun hayvana yapılır.", items: ["Dana ve düve seçenekleri", "Kapora ile ön kayıt", "WhatsApp ile bilgi", "Müşteri paneli takibi yakında"] },
  { icon: "ri-cow-line", title: "Kurbanlık Satışı", desc: "Büyükbaş ve küçükbaş kurbanlık seçenekleri için kontrollü ve düzenli satış süreci yürütülür.", items: ["Büyükbaş seçenekleri", "Küçükbaş seçenekleri", "Kesim planı", "Teslimat organizasyonu"] },
  { icon: "ri-heart-line", title: "Adaklık Hizmeti", desc: "Adaklık ve özel kesim ihtiyaçları için iletişim, planlama ve kesim süreci WhatsApp üzerinden takip edilir.", items: ["Adaklık bilgi", "Özel kesim planı", "Parçalama", "Teslimat desteği"] },
];

export default function ServicesPage() {
  const content = usePublicSiteContent();

  return (
    <div className="min-h-screen bg-farm-cream font-body">
      <Navbar />
      <section className="bg-farm-cream px-4 pt-14 pb-10">
        <div className="max-w-6xl mx-auto">
          <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">HİZMETLER</span>
          <div className="mt-3 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 items-end">
            <div>
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-farm-brown leading-tight">Kurbanlık, adaklık ve hisseli satış hizmetleri</h1>
              <p className="mt-4 font-body text-base text-farm-muted leading-relaxed">Hizmetlerimizi sade, anlaşılır ve WhatsApp üzerinden kolayca ulaşılabilir bir yapıda sunuyoruz.</p>
            </div>
            <div className="rounded-[28px] border border-farm-border bg-farm-warm p-6 shadow-sm">
              <p className="font-heading text-2xl font-bold text-farm-brown">Kayıt işlemleri WhatsApp üzerinden yapılmaktadır.</p>
              <a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="mt-5 inline-flex items-center gap-2 rounded-2xl bg-farm-green px-5 py-3 text-white font-body font-bold hover:bg-farm-green/90 transition-colors"><i className="ri-whatsapp-line text-xl" />{content.contactPhone}</a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-farm-cream px-4 pb-16">
        <div className="max-w-6xl mx-auto rounded-[28px] border border-farm-earth/20 bg-farm-warm p-5 md:p-8 shadow-sm">
          <div className="text-center mb-6">
            <span className="font-body text-xs font-bold tracking-[0.24em] text-farm-earth">HİSSELİ SATIŞ PAKETLERİ</span>
            <h2 className="mt-1 font-heading text-3xl md:text-4xl font-bold text-farm-brown">2026 Paketleri</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {packages.map((item, index) => (
              <div key={item.title} className="relative rounded-[24px] border border-farm-earth/20 bg-farm-cream p-5 text-center shadow-sm overflow-hidden">
                <div className="absolute left-0 top-0 h-1.5 w-full bg-gradient-to-r from-farm-earth via-farm-gold to-farm-green" />
                <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-farm-earth-light text-farm-brown"><i className={`${index === 4 ? "ri-leaf-line" : "ri-cow-line"} text-xl`} /></div>
                <h3 className="font-heading text-2xl font-bold text-farm-brown">{item.title}</h3>
                <p className="font-body text-sm font-semibold text-farm-muted">{item.type}</p>
                <div className="mx-auto mt-3 inline-flex rounded-full bg-farm-earth-pale px-4 py-1 text-sm font-bold text-farm-brown">{item.kg}</div>
                <p className="mt-4 font-heading text-3xl font-bold text-farm-brown">{item.price}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-farm-warm py-16 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">
          {services.map((service) => (
            <div key={service.title} className="rounded-[28px] border border-farm-border bg-farm-cream p-7 shadow-sm">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-farm-green-pale text-farm-green"><i className={`${service.icon} text-3xl`} /></div>
              <h2 className="mt-5 font-heading text-2xl font-bold text-farm-brown">{service.title}</h2>
              <p className="mt-2 font-body text-sm text-farm-muted leading-relaxed">{service.desc}</p>
              <ul className="mt-5 space-y-2">{service.items.map((item) => (<li key={item} className="flex items-center gap-2 font-body text-sm text-farm-muted"><i className="ri-checkbox-circle-line text-farm-green" />{item}</li>))}</ul>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-farm-cream py-16 px-4">
        <div className="max-w-6xl mx-auto rounded-[28px] border border-farm-border bg-farm-warm p-6 md:p-8 shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div><h2 className="font-heading text-3xl font-bold text-farm-brown">Bilgi almak veya kayıt oluşturmak için</h2><p className="mt-2 font-body text-sm text-farm-muted">Müşteri kaydı ve sipariş görüşmeleri WhatsApp üzerinden ilerler.</p></div>
          <div className="flex flex-col sm:flex-row gap-3"><a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-farm-green px-6 py-3 text-white font-body font-bold hover:bg-farm-green/90 transition-colors"><i className="ri-whatsapp-line text-xl" />WhatsApp ile Kayıt Ol</a><Link to="/giris" className="inline-flex items-center justify-center gap-2 rounded-2xl bg-farm-brown px-6 py-3 text-white font-body font-bold hover:bg-farm-earth transition-colors">Müşteri Girişi</Link></div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
